var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Recursion',{attrs:{"data":_vm.newData,"vocabulary":_vm.vocabulary,"level":0,"isRenderEmpty":_vm.isRenderEmpty,"specialClasses":_vm.specialClasses}})}
var staticRenderFns = []

export { render, staticRenderFns }